// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// RxJS
import { Observable, of } from 'rxjs';
// CRUD
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../../_base/crud';

import { Global } from '../../../../shared/global';
// Models
import { VehicleModel } from '../_models/vehicle.model';
import { mergeMap } from 'rxjs/operators';
import { ShareddataserviceService } from '../../../../shared/shareddataservice.service';

const API_CUSTOMERS_URL = Global.BASE_VEHICLE_ENDPOINT;
const API_URL = Global.BASE_VEHICLE_BY_COMPANYMID;

@Injectable()
export class VehicleService {
	loggedCompanyMId: number;

	constructor(private http: HttpClient, private httpUtils: HttpUtilsService,
		private sharedService: ShareddataserviceService) { }

	getLoggedCompanyMId() {
		this.sharedService.companydata.subscribe(data => this.loggedCompanyMId = data[0]["CompanyMId"]);
	}

	// CREATE =>  POST: add a new vehicle to the server
	createVehicle(vehicle: VehicleModel): Observable<VehicleModel> {
		// Note: Add headers if needed (tokens/bearer)
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<VehicleModel>(API_CUSTOMERS_URL, vehicle, { headers: httpHeaders});
	}

	uploadImage(imageFile: File, imageName:any): Observable<any> {
		let formData = new FormData();
		formData.append('ImageFile', imageFile, imageFile.name);
		formData.append('imageName', imageName);

		const httpHeaders = new HttpHeaders();
		httpHeaders.set('Content-Type', 'multipart/form-data');

		const url = "Global.BASE_UPLOAD_CATEGORY_IMAGE_ENDPOINT";
		// Note: Add headers if needed (tokens/bearer)
		return this.http.post<any>(url, formData, { headers: httpHeaders });
	}

	// READ
	getAllVehicles(): Observable<VehicleModel[]> {
		this.getLoggedCompanyMId();
		const URL = API_URL + this.loggedCompanyMId;
		return this.http.get<VehicleModel[]>(URL);
	}

	getVehicleById(VehicleMId: number): Observable<VehicleModel> {
		return this.http.get<VehicleModel>(API_CUSTOMERS_URL + `/${VehicleMId}`);
	}

	// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
	// items => filtered/sorted result
	// Server should return filtered/sorted result
	findVehicles(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		// Note: Add headers if needed (tokens/bearer)
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);

		this.getLoggedCompanyMId();
		const URL = API_URL + this.loggedCompanyMId;
		return this.http.get<QueryResultsModel[]>(URL).pipe(
            mergeMap(res => {
                const result = this.httpUtils.baseFilter(res, queryParams);
                return of(result);
            })
        );
	}

	// UPDATE => PUT: update the vehicle on the server
	updateVehicle(VehicleMId: number, vehicle: VehicleModel): Observable<any> {
		const httpHeader = this.httpUtils.getHTTPHeaders();
		return this.http.put(API_CUSTOMERS_URL + VehicleMId, vehicle, { headers: httpHeader });
	}

	// DELETE => delete the vehicle from the server
	deleteVehicle(VehicleMId: number): Observable<VehicleModel> {
		const url = `${API_CUSTOMERS_URL}${VehicleMId}`;
		return this.http.delete<VehicleModel>(url);
	}
}
